export class OfferType {
  id?: number;
  name?:string;
  descr?:string;
  isAdvertisement?:string;
  isLeaseBuyPlan?:string;
  isMultiBuy:string;
  statusName?:string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/offerType.ts